import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore"; // Importa o Firestore

const firebaseConfig = {
  apiKey: "AIzaSyBFns55mvPu3k0D5jE26wqfWZPFhkO8U2M",
  authDomain: "shotcompany-dd557.firebaseapp.com",
  projectId: "shotcompany-dd557",
  storageBucket: "shotcompany-dd557.firebasestorage.app",
  messagingSenderId: "792469624493",
  appId: "1:792469624493:web:e862864b3d7a9135dad824",
  measurementId: "G-FD9CSTM9KZ"
};

// Inicializa o aplicativo Firebase
const app = initializeApp(firebaseConfig);

// Inicializa o serviço de autenticação
const auth = getAuth(app);

// Inicializa o Firestore
const db = getFirestore(app); // Adiciona esta linha

// Exporta os serviços para uso em outras partes do aplicativo
export { auth, db }; // Exporta também o db
